var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPbgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 497.9 91",
    style: {
      enableBackground: "new 0 0 497.9 91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F55036;}\n\t.st1{fill:#666666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000047740885223744833820000002654528683820789689_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,31.7c0,4.6-3.4,7.4-8.9,7.4H2.3V46H0V24.3h8.1C13.7,24.3,17,27,17,31.7L17,31.7z M14.7,31.7 c0-3.5-2.3-5.5-6.6-5.5H2.3v10.9h5.8C12.4,37.1,14.7,35.1,14.7,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,35.1c0-6.3,4.8-11,11.4-11s11.4,4.7,11.4,11s-4.9,11-11.4,11S22.7,41.4,22.7,35.1z M43.2,35.1 c0-5.2-3.9-9-9.1-9s-9.2,3.8-9.2,9s3.9,9,9.2,9C39.3,44.1,43.2,40.3,43.2,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.1,24.3L74.8,46h-2.4L66,27.4L59.6,46h-2.4l-7.3-21.7h2.4l6.3,18.7L65,24.3h2.1L73.6,43l6.4-18.8 L82.1,24.3L82.1,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,44v2H88.6V24.3h14.9v2H90.9V34h11.2v2H90.9V44L104,44L104,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.6,46l-5-7c-0.6,0.1-1.1,0.1-1.7,0.1H114V46h-2.3V24.3h8.1c5.5,0,8.9,2.8,8.9,7.4c0,3.4-1.8,5.8-5,6.8 l5.3,7.4L126.6,46L126.6,46z M126.4,31.7c0-3.5-2.3-5.5-6.6-5.5H114v10.9h5.8C124.1,37.1,126.4,35.1,126.4,31.7L126.4,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.8,44v2h-15.4V24.3h14.9v2h-12.6V34H150v2h-11.2V44L151.8,44L151.8,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.6,24.3h8.8c7,0,11.6,4.5,11.6,10.9S175.4,46,168.4,46h-8.8V24.3z M168.3,44c5.8,0,9.5-3.7,9.5-8.9 s-3.7-8.9-9.5-8.9h-6.4V44H168.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.1,40.2c0,3.7-2.7,5.8-8.2,5.8h-10V24.3h9.4c4.8,0,7.6,2,7.6,5.6c0,2.5-1.3,4.1-3.3,4.9 C214.5,35.4,216.1,37.2,216.1,40.2L216.1,40.2z M200.3,26.1V34h6.9c3.5,0,5.5-1.3,5.5-3.9s-2-3.9-5.5-3.9L200.3,26.1L200.3,26.1z  M213.8,40c0-2.8-2.1-4.1-5.9-4.1h-7.7v8.2h7.7C211.8,44.1,213.8,42.8,213.8,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.7,38.5V46h-2.3v-7.5l-8.7-14.2h2.5l7.4,12.2l7.4-12.2h2.3L230.7,38.5L230.7,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.4,5.8c-16.1,0-29.2,13.1-29.2,29.2s13.1,29.2,29.2,29.2c16.1,0,29.2-13.1,29.2-29.2S409.5,5.8,393.4,5.8 z M393.4,53.3c-10.1,0-18.3-8.2-18.3-18.3s8.2-18.3,18.3-18.3c10.1,0,18.3,8.2,18.3,18.3S403.4,53.3,393.4,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353,5.9c-1-0.1-2-0.2-3-0.2c-0.5,0-1,0-1.5,0c-0.5,0-1,0.1-1.5,0.1c-2,0.2-3.9,0.5-5.8,1 c-3.8,1-7.5,2.8-10.7,5.4c-3.2,2.5-5.8,5.9-7.6,9.6c-0.9,1.9-1.5,3.9-1.9,5.9c-0.2,1-0.3,2-0.4,3c0,0.5-0.1,1-0.1,1.5l0,0.8v0.4 l0,0.3l0,9.8l0,9.8l0.1,9.8h11l0.1-9.8l0-9.8l0-9.8v-0.3l0-0.2l0-0.5c0-0.3,0-0.6,0.1-0.9c0.1-0.6,0.2-1.2,0.3-1.8 c0.2-1.2,0.6-2.3,1.1-3.4c1-2.2,2.5-4.1,4.4-5.6c1.9-1.5,4.2-2.7,6.6-3.4c1.2-0.3,2.5-0.6,3.8-0.7c0.3,0,0.7-0.1,1-0.1 c0.3,0,0.7,0,1,0c0.6,0,1.3,0,1.9,0.1c2.5,0.2,4.9,1,7.1,2.2l5.5-9.5C360.9,7.6,357,6.4,353,5.9L353,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283,5.6c-16.1,0-29.2,13.1-29.2,29.2s13.1,29.2,29.2,29.2h9.6v-11H283c-10.1,0-18.3-8.2-18.3-18.3 S273,16.6,283,16.6s18.3,8.2,18.3,18.3l0,0v26.9l0,0c0,10-8.1,18.2-18.1,18.3c-4.8-0.1-9.3-1.9-12.7-5.3l-7.8,7.8 c5.4,5.4,12.6,8.5,20.3,8.6l0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0l0,0c15.9-0.2,28.8-13.2,28.8-29.1l0-27.8 C311.9,18.4,298.9,5.6,283,5.6L283,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.9,5.8c-16.1,0-29.2,13.1-29.2,29.2s13.1,29.2,29.2,29.2h10v-11h-10c-10.1,0-18.3-8.2-18.3-18.3 s8.2-18.3,18.3-18.3c9.5,0,17.4,7.4,18.2,16.7h0v56.1h11V35l0,0C487,18.9,474,5.8,457.9,5.8L457.9,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.9,5.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.3-2.4-5.3-5.4s2.3-5.4,5.4-5.4S497.9,2.3,497.9,5.3L497.9,5.3z M497.3,5.3 c0-2.7-2-4.8-4.8-4.8s-4.8,2.1-4.8,4.8s2.1,4.8,4.8,4.8C495.2,10.1,497.3,8,497.3,5.3L497.3,5.3z M493.9,6.2l1.4,2.2h-0.8l-1.3-2 c-0.1,0-0.2,0-0.3,0h-1.6v2h-0.8V2.3h2.4c1.5,0,2.4,0.8,2.4,2C495.2,5.3,494.7,5.9,493.9,6.2L493.9,6.2z M494.4,4.3 c0-0.9-0.6-1.4-1.7-1.4h-1.5v2.8h1.5C493.8,5.7,494.4,5.2,494.4,4.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbgLogo);
export default __webpack_public_path__ + "static/media/pbg_logo.a1048da520e027da5c124ae760013fc0.svg";
export { ForwardRef as ReactComponent };